import React from "react";
import HeaderSectionReusableComponent from "../../component/ReusablaeComponent/HeaderSectionReusableComponent";
import PointsComponent from "../../component/ReusablaeComponent/PointsComponent";
import PointsWithHeading from "../../component/ReusablaeComponent/PointsWithHeading";
import HeadingParagraphSection from "../../component/ReusablaeComponent/HeadingParagraphSection";
import supplychaimanagement from '../../../Assets/SuuplyChainManagement.png';
import SCMSolutions from '../../../Assets/SCMSolutions.png';
import SCMChoose from '../../../Assets/SCMChoose.png';
import BenifitsSCM from '../../../Assets/BenifitsSCM.png'
import Image_ContentReusableComponent from "../../component/ReusablaeComponent/Image_ContentReusableComponent";

const SupplyChainManagement = () => {
const features = [
  {
    strongText: "Enhanced supply chain visibility:",
    text: "Get holistic, real-time visibility across your supply chain. Integrate with other systems for seamless data flow, reduced risk, and improved decision-making and transparency.",
  },
  {
    strongText: "Unmatched supply chain resilience:",
    text: "Leverage data-driven insights and predictions to address disruption, unexpected events, and change. Ensure continuity with robust planning and an intelligent control tower.",
  },
  {
    strongText: "Support ESG and Sustainability Goals:",
    text: "Provides data and embedded processes to support your efforts in reducing waste and emissions, tracing materials, complying to regulations, and more.",
  },
];

  return (
    <div>
    <Image_ContentReusableComponent
        heading="Modernize your supply chain with SCM software"
        paragraph="Digitize your supply chain with Infor Supply Chain Management (SCM) 
            software. Cloud-native and powered by AI and machine learning (ML), our 
            solutions offer real-time connectivity, improved decision-making, and enhanced 
            visibility – for greater supply chain resilience." 
        imgsrc={SCMChoose}
        reverse={false}
        bgColor="#ffffff"
        headingColor="#00399e"   
        headingSize="2.5rem"       
        textColor="#4B5563"     
      />

    <Image_ContentReusableComponent
        heading="What is SCM software?"
        paragraph="Supply chain management (SCM) software supports all the processes needed to produce goods and deliver them to customers, from planning and procurement to manufacturing   and logistics. Today’s SCM software is cloud-based and uses advanced digital technologies such as AI and the Internet of Things (IoT) – to drive transformation and agility."     
        imgsrc={SCMChoose}
        reverse={true}
        bgColor="#ffffff"
        headingColor="#00399e"    
        headingSize="2.5rem"    
        textColor="#4B5563"      
      />
         {/* <PointsComponent
        title="Our SCM Solutions"
          description="We offer comprehensive SCM solutions tailored to your business needs, including:"
        listItems={[
          "Demand forecasting and inventory management",
          "Supplier relationship management",
          "Transportation and logistics optimization",
          "Warehouse and order fulfillment management",
         
        ]}
        imageSrc={SCMSolutions}
        altText="SCMSolutions"
      /> */}

       <PointsWithHeading
        title="Key benefits of our supply chain management software"
        description={"Infor Supply Chain Management offers AI-powered, cloud-based tools for planning, forecasting, production scheduling, supplier collaboration, warehousing, and logistics. These tools work together to synchronize your end-to-end supply chain – and improve visibility, resilience, and sustainability"}
        reverse={false}
        features={features}
        imageSrc={BenifitsSCM}
        headingColor="#00399e"    
        headingSize="2.5rem"  
        altText="BenifitsSCM"
      />
      
      {/* <HeadingParagraphSection
      bgColor='#fff'
        heading={
          "Sustainability in Supply Chain"
        }
        paragraph={
          <>
           We are committed to creating environmentally responsible supply chains by 
          optimizing operations to reduce carbon emissions, minimizing waste, and 
          promoting the use of sustainable materials. Our solutions enable businesses to 
          implement eco-friendly practices across sourcing, manufacturing, and logistics, 
          ensuring a greener and more efficient supply chain. We help clients meet their 
          sustainability goals while maintaining operational efficiency and cost-effectiveness.
          </>
        }
      /> */}
      {/* <PointsComponent
        title="Why Choose Us?"
          bgColor="#efefef"
        listItems={[
          "Proven track record of delivering results",
          "Cutting-edge technology integration",
          "Experienced team of supply chain experts",
          "End-to-end support from planning to execution",
          
        ]}
        imageSrc={SCMChoose}
        altText="SCMChoose"
      /> */}
      <h1 className="text-center m-10 font-bold" style={{color:"#cc2029"}}>INFOR SUPPLY CHAIN PLANNING</h1>
      <PointsComponent
        title="Supply chain planning"
          description="Synchronize supply and demand with our integrated, cloud-native supply chain planning portfolio. Leverage advanced modeling, AI and machine learning, and analytics to plan and adapt to the unexpected. 
          The portfolio includes the following solutions that can be bought together or separately:"
        listItems={[
          "Infor Integrated Business Planning (Sales and Operations Planning)",
          "Infor Demand Forecasting",
          "Infor Supply Planning",
          "Infor Production Scheduling",
        ]}
        imageSrc={SCMChoose}
        altText="EmpowerBusiness"
        reverse={true}
        headingColor=" #d95b25"    
        headingSize="2.5rem"  
      />

      <div className="py-32">
        <HeaderSectionReusableComponent
        mainHeading={"Cloud-based supply chain software solutions"}
        paragragh={
          <>
            Digitize, automate, and manage your end-to-end supply chain with a complete portfolio of SCM software. Our cloud-native solutions work seamlessly with your ERP, providing the data and insights needed to achieve supply chain excellence.
          </>
        }
        imgScr={SCMChoose}
        altText='ProductLifeCycle'
      />
      </div>
    </div>
  );
};

export default SupplyChainManagement;
